import React, { useEffect } from 'react';
import Modal from 'react-modal';
import '../../../style/ConfirmationFeedDeleteModal.css';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import Loading from '../../../utils/Loading';

function ConfirmationModal({ modalIsOpen, afterOpenModal, closeModal, confirmation, message, subMessage = '', processing = false }: any) {
	useEffect(() => {
		const element = document.getElementById('home');
		if (modalIsOpen) {
			Modal.setAppElement('#root');

			if (!!element) element.style.filter = 'blur(5px)';
		} else {
			if (!!element) element.style.filter = 'unset';
		}
	}, [modalIsOpen]);

	return (
		<Modal
			isOpen={modalIsOpen}
			onAfterOpen={afterOpenModal}
			onRequestClose={closeModal}
			contentLabel='Example Modal'
			style={{
				overlay: {
					zIndex: 10,
					background: '#00000045',
				},
				content: {
					width: 600,
					height: 450,
					padding: 0,
					opacity: 1,
					minWidth: 600,
					margin: 'auto',
					marginTop: '2%',
					backgroundColor: 'transparent',
					maxHeight: '90%',
					border: 'none',
					boxShadow: 'none',
					overflow: 'hidden',
				},
			}}
		>
			<div className='bg-white rounded-xl flex flex-col h-full items-center justify-between p-10'>
				<ConfirmIcon />
				<p className='text-primaryViolet text-xl font-bold text-center'>{message}</p>
				<p className='text-mudPurple text-sm mt-2 text-center'>{subMessage}</p>

				<div className='flex flex-row justify-between items-center w-full mt-6'>
					<div
						className='bg-white hover:bg-grey-600 border border-grey-600 cursor-pointer flex items-center justify-center text-grey-600 hover:text-white text-base font-bold rounded-xl w-[250px] h-[55px] transition'
						onClick={() => closeModal()}
					>
						Cancel
					</div>
					<button
						className='border bg-white hover:bg-redError cursor-pointer flex items-center justify-center border-redError text-redError hover:text-white text-base font-bold rounded-xl w-[250px] h-[55px] transition'
						onClick={() => confirmation()}
						disabled={processing}
					>
						{processing ? <Loading /> : <p className=''>Ok</p>}
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default ConfirmationModal;
